import { render, staticRenderFns } from "./StatusLabel.vue?vue&type=template&id=08a149cb&lang=pug&"
import script from "./StatusLabel.vue?vue&type=script&lang=ts&"
export * from "./StatusLabel.vue?vue&type=script&lang=ts&"
import style0 from "./StatusLabel.vue?vue&type=style&index=0&id=08a149cb&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports